
export const allowedExtensions = [
    "application/pdf", // PDF
    "application/x-zip-compressed", // ZIP (alguns browsers)
    "application/zip", // ZIP
    "application/msword", // DOC
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    "application/vnd.ms-excel", // XLS
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
    "application/vnd.ms-powerpoint", // PPT
    "application/vnd.openxmlformats-officedocument.presentationml.presentation" // PPTX
];

export const mapFileTypeToEnum = (fileType) => {
    switch (fileType) {
      case "application/pdf":
        return 4; // Pdf
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return 1; // Word
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return 2; // Excel
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return 3; // PowerPoint
      case "application/zip":
      case "application/x-zip-compressed":
        return 5; // Zip
      default:
        return 0; // Valor default se o tipo não for reconhecido
    }
  };
